import { defineComponent as w, ref as V, provide as j, watch as g, unref as m, onMounted as q, onBeforeUnmount as x, nextTick as I } from "vue";
import { useFocusReason as J, tryFocus as d, createFocusOutPreventedEvent as T, getEdges as M, focusableStack as U, focusFirstDescendant as Y, obtainAllFocusableElements as z, isFocusCausedByUserEvent as G } from "./index760.js";
import { ON_TRAP_FOCUS_EVT as K, ON_RELEASE_FOCUS_EVT as k, FOCUS_TRAP_INJECTION_KEY as H, FOCUS_AFTER_TRAPPED as y, FOCUS_AFTER_TRAPPED_OPTS as N, FOCUS_AFTER_RELEASED as L } from "./index761.js";
import { useEscapeKeydown as Q } from "./index707.js";
import { getEventCode as W } from "./index589.js";
import { isString as X } from "./index575.js";
import { EVENT_CODE as Z } from "./index590.js";
import $ from "./index567.js";
var fe = w({
  name: "ElFocusTrap",
  inheritAttrs: !1,
  props: {
    loop: Boolean,
    trapped: Boolean,
    focusTrapEl: Object,
    focusStartEl: {
      type: [Object, String],
      default: "first"
    }
  },
  emits: [
    K,
    k,
    "focusin",
    "focusout",
    "focusout-prevented",
    "release-requested"
  ],
  setup(n, { emit: r }) {
    const o = V();
    let i, v;
    const { focusReason: l } = J();
    Q((e) => {
      n.trapped && !f.paused && r("release-requested", e);
    });
    const f = {
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    }, E = (e) => {
      if (!n.loop && !n.trapped || f.paused) return;
      const { altKey: t, ctrlKey: s, metaKey: a, currentTarget: u, shiftKey: _ } = e, { loop: D } = n, B = W(e) === Z.tab && !t && !s && !a, p = document.activeElement;
      if (B && p) {
        const C = u, [O, b] = M(C);
        if (O && b) {
          if (!_ && p === b) {
            const c = T({
              focusReason: l.value
            });
            r("focusout-prevented", c), c.defaultPrevented || (e.preventDefault(), D && d(O, !0));
          } else if (_ && [O, C].includes(p)) {
            const c = T({
              focusReason: l.value
            });
            r("focusout-prevented", c), c.defaultPrevented || (e.preventDefault(), D && d(b, !0));
          }
        } else if (p === C) {
          const c = T({
            focusReason: l.value
          });
          r("focusout-prevented", c), c.defaultPrevented || e.preventDefault();
        }
      }
    };
    j(H, {
      focusTrapRef: o,
      onKeydown: E
    }), g(
      () => n.focusTrapEl,
      (e) => {
        e && (o.value = e);
      },
      { immediate: !0 }
    ), g([o], ([e], [t]) => {
      e && (e.addEventListener("keydown", E), e.addEventListener("focusin", F), e.addEventListener("focusout", P)), t && (t.removeEventListener("keydown", E), t.removeEventListener("focusin", F), t.removeEventListener("focusout", P));
    });
    const S = (e) => {
      r(K, e);
    }, A = (e) => r(k, e), F = (e) => {
      const t = m(o);
      if (!t) return;
      const s = e.target, a = e.relatedTarget, u = s && t.contains(s);
      n.trapped || a && t.contains(a) || (i = a), u && r("focusin", e), !f.paused && n.trapped && (u ? v = s : d(v, !0));
    }, P = (e) => {
      const t = m(o);
      if (!(f.paused || !t))
        if (n.trapped) {
          const s = e.relatedTarget;
          !$(s) && !t.contains(s) && setTimeout(() => {
            if (!f.paused && n.trapped) {
              const a = T({
                focusReason: l.value
              });
              r("focusout-prevented", a), a.defaultPrevented || d(v, !0);
            }
          }, 0);
        } else {
          const s = e.target;
          s && t.contains(s) || r("focusout", e);
        }
    };
    async function R() {
      await I();
      const e = m(o);
      if (e) {
        U.push(f);
        const t = e.contains(
          document.activeElement
        ) ? i : document.activeElement;
        if (i = t, !e.contains(t)) {
          const a = new Event(
            y,
            N
          );
          e.addEventListener(y, S), e.dispatchEvent(a), a.defaultPrevented || I(() => {
            let u = n.focusStartEl;
            X(u) || (d(u), document.activeElement !== u && (u = "first")), u === "first" && Y(
              z(e),
              !0
            ), (document.activeElement === t || u === "container") && d(e);
          });
        }
      }
    }
    function h() {
      const e = m(o);
      if (e) {
        e.removeEventListener(y, S);
        const t = new CustomEvent(L, {
          ...N,
          detail: {
            focusReason: l.value
          }
        });
        e.addEventListener(L, A), e.dispatchEvent(t), !t.defaultPrevented && (l.value == "keyboard" || !G() || e.contains(document.activeElement)) && d(i ?? document.body), e.removeEventListener(L, A), U.remove(f), i = null, v = null;
      }
    }
    return q(() => {
      n.trapped && R(), g(
        () => n.trapped,
        (e) => {
          e ? R() : h();
        }
      );
    }), x(() => {
      n.trapped && h(), o.value && (o.value.removeEventListener("keydown", E), o.value.removeEventListener("focusin", F), o.value.removeEventListener("focusout", P), o.value = void 0), i = null, v = null;
    }), {
      onKeydown: E
    };
  }
});
export {
  fe as default
};
